/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_bulkUpdateInterviewSchedulesRequest } from '../models/api_bulkUpdateInterviewSchedulesRequest';
import type { api_createInterviewScheduleBeneficiariesRequest } from '../models/api_createInterviewScheduleBeneficiariesRequest';
import type { api_createInterviewScheduleRequest } from '../models/api_createInterviewScheduleRequest';
import type { api_createInterviewScheduleResponse } from '../models/api_createInterviewScheduleResponse';
import type { api_sendInterviewInvitationsRequest } from '../models/api_sendInterviewInvitationsRequest';
import type { api_sendMarshallInterviewInvitationsRequest } from '../models/api_sendMarshallInterviewInvitationsRequest';
import type { db_GetInterviewScheduleRow } from '../models/db_GetInterviewScheduleRow';
import type { db_ListInterviewSchedulesRow } from '../models/db_ListInterviewSchedulesRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InterviewSchedules {
    /**
     * Get a list of interview schedules
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListInterviewSchedulesRow OK
     * @throws ApiError
     */
    public static listInterviewSchedules(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListInterviewSchedulesRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/interview-schedules',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a new interview schedule
     * @param body Interview schedule details
     * @returns api_createInterviewScheduleResponse OK
     * @throws ApiError
     */
    public static createInterviewSchedule(
        body: api_createInterviewScheduleRequest,
    ): CancelablePromise<api_createInterviewScheduleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/interview-schedules',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update status of beneficiaries
     * @param body Beneficiary IDs and Interview schedule ID
     * @returns void
     * @throws ApiError
     */
    public static createInterviewScheduleBeneficiaries(
        body: api_createInterviewScheduleBeneficiariesRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/interview-schedules/beneficiaries',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Bulk update interview schedules
     * @param body Bulk update interview schedule details
     * @returns void
     * @throws ApiError
     */
    public static bulkUpdateInterviewSchedules(
        body: api_bulkUpdateInterviewSchedulesRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/interview-schedules/bulk-update',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Send interview invitations
     * @param body Beneficiary IDs
     * @returns void
     * @throws ApiError
     */
    public static sendInterviewInvitations(
        body: api_sendInterviewInvitationsRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/interview-schedules/send-invitations',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Send Marshall interview invitation letters to applicants with an assigned interview slot
     * @param body Beneficiary IDs
     * @returns void
     * @throws ApiError
     */
    public static sendMarshallInterviewInvitations(
        body: api_sendMarshallInterviewInvitationsRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/interview-schedules/send-marshall-invitations',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an interview schedule
     * @param id Interview schedule ID
     * @returns db_GetInterviewScheduleRow OK
     * @throws ApiError
     */
    public static getInterviewSchedule(
        id: number,
    ): CancelablePromise<db_GetInterviewScheduleRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/interview-schedules/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an interview schedule
     * @param id Interview schedule ID
     * @param body Interview schedule details
     * @returns api_createInterviewScheduleResponse OK
     * @throws ApiError
     */
    public static updateInterviewSchedule(
        id: number,
        body: api_createInterviewScheduleRequest,
    ): CancelablePromise<api_createInterviewScheduleResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/interview-schedules/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
